import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "w-full" }, "Add", -1)
const _hoisted_2 = { class: "flex items-center gap-2 sm:gap-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Add", -1)
const _hoisted_4 = {
  key: 0,
  class: "text-black text-start flex flex-col gap-2 sm:gap-4 py-1 sm:py-2 overflow-hidden"
}
const _hoisted_5 = { class: "cursor-pointer hover:brightness-75 ease-in duration-200 rounded-md shadow-md bg-white overflow-hidden" }
const _hoisted_6 = { class: "flex items-center justify-between gap-2 sm:gap-4 overflow-hidden" }
const _hoisted_7 = { class: "text-black px-2 m-auto sm:block hidden overflow-hidden whitespace-nowrap text-ellipsis" }
const _hoisted_8 = { class: "flex flex-wrap justify-center items-center w-full sm:w-fit max-h-[12rem] sm:max-h-full sm:grid sm:grid-cols-[repeat(3,_minmax(8rem,_1fr))] gap-1 sm:gap-2 overflow-hidden" }
const _hoisted_9 = { class: "text-black pl-4 text-center sm:text-start py-2 sm:hidden overflow-hidden whitespace-nowrap text-ellipsis" }
const _hoisted_10 = {
  key: 1,
  class: "text-black text-start flex flex-col gap-2 sm:gap-4 py-1 sm:py-2 overflow-hidden"
}
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center justify-between gap-2 sm:gap-4 animate-pulse\"><div class=\"px-2 m-auto sm:block hidden w-1/5 max-w-[16rem] h-4 bg-gray-300 rounded-full\"></div><div class=\"flex flex-wrap justify-center items-center w-full sm:w-fit max-h-[12rem] sm:max-h-full sm:grid sm:grid-cols-[repeat(3,_minmax(8rem,_1fr))] gap-1 sm:gap-2 overflow-hidden\"><div class=\"w-32 h-48 bg-gray-300\"></div><div class=\"w-32 h-48 bg-gray-300\"></div><div class=\"w-32 h-48 bg-gray-300\"></div></div></div><div class=\"m-auto my-2 sm:hidden w-1/5 max-w-[16rem] h-[1.12rem] bg-gray-300 rounded-full animate-pulse\"></div>", 2)
const _hoisted_13 = [
  _hoisted_11
]
const _hoisted_14 = { class: "bg-white rounded-md py-1 sm:py-2 px-2 sm:px-4 mt-1 sm:mt-2" }

import { ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { Pagination, Modal, Input } from 'ant-design-vue';
import { PlusOutlined } from '@ant-design/icons-vue';
import ImageLoading from '@/components/shared/ImageLoading.vue';
import { Metadata } from '@/model/api';
import { DocumentType, Documentor, DocumentorPaginationRequest } from '@/model/document';
import { getDocumentorPagination } from '@/repository/document';


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewDocumentor',
  props: {
    documentType: {},
    refName: {}
  },
  setup(__props: any) {

const props = __props;



const route = useRoute();
const router = useRouter();

const metadata = ref<Metadata>(initialMetadata());
function initialMetadata(): Metadata {
	return {
		limit: Number(route.query.limit) || 10,
		offset: 0,
		totalItem: 0,
		totalPage: 0,
		currentPage: Number(route.query.page) || 1
	};
}

const documentors = ref<Documentor[]>([]);
const isFetching = ref(false);
const search = ref((route.query?.search as string) || '');
const openModal = ref(false);
const metadataName = ref('');

fetchData();
async function fetchData() {
	const sort = 'name asc';
	const req: DocumentorPaginationRequest = {
		page: metadata.value.currentPage,
		offset: metadata.value.offset,
		limit: metadata.value.limit,
		metadataName: search.value,
		documentType: props.documentType,
		sort
	};
	router.replace({
		query: {
			page: metadata.value.currentPage,
			limit: metadata.value.limit,
			search: search.value || undefined
		}
	});
	isFetching.value = true;
	const data = await getDocumentorPagination(req);
	if (data) {
		documentors.value = data.data || [];
		metadata.value = data.metadata;
		isFetching.value = false;
		if (metadata.value.totalPage > 0 && (!data.data || !data.data.length)) {
			metadata.value.currentPage = metadata.value.totalPage;
		}
	}
}

watch(
	() => metadata?.value.currentPage,
	async () => (metadata?.value.currentPage !== 0 ? await fetchData() : {})
);
watch(
	() => metadata?.value.limit,
	async () => await fetchData()
);
watch(
	() => openModal.value,
	() => (metadataName.value = '')
);

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_empty = _resolveComponent("a-empty")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Modal), {
      ref: "modalRef",
      open: openModal.value,
      "onUpdate:open": _cache[4] || (_cache[4] = ($event: any) => ((openModal).value = $event)),
      "wrap-style": { overflow: 'hidden' }
    }, {
      title: _withCtx(() => [
        _hoisted_1
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          key: "back",
          onClick: _cache[2] || (_cache[2] = () => (openModal.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancel")
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          key: "submit",
          type: "primary",
          disabled: !metadataName.value.length,
          onClick: _cache[3] || (_cache[3] = () => _unref(router).push({ path: `/${_ctx.documentType}/${metadataName.value}/create` }))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" OK ")
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("span", null, "Please enter new " + _toDisplayString(_ctx.refName) + " name", 1),
        _createVNode(_unref(Input), {
          value: metadataName.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((metadataName).value = $event)),
          placeholder: `Enter an ${_ctx.refName} name`,
          onKeydown: _cache[1] || (_cache[1] = 
				(event) => {
					if (event.key === 'Enter') {
						_unref(router).push({ path: `/${_ctx.documentType}/${metadataName.value}/create` });
					}
				}
			)
        }, null, 8, ["value", "placeholder"])
      ]),
      _: 1
    }, 8, ["open"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_input_search, {
        value: search.value,
        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((search).value = $event)),
        placeholder: `Search ${_ctx.refName} name ...`,
        "enter-button": "",
        "allow-clear": "",
        onSearch: _cache[6] || (_cache[6] = ($event: any) => (fetchData())),
        class: "my-1 sm:my-2"
      }, null, 8, ["value", "placeholder"]),
      _createVNode(_component_a_tooltip, { placement: "topRight" }, {
        title: _withCtx(() => [
          _hoisted_3
        ]),
        default: _withCtx(() => [
          _createVNode(_component_a_button, {
            class: "rounded-md border-none bg-green-200 hover:bg-green-400 !text-black",
            onClick: _cache[7] || (_cache[7] = () => (openModal.value = true))
          }, {
            icon: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(PlusOutlined))))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    (!isFetching.value && documentors.value?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documentors.value, (documentor, index) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: index,
              to: '/' + _ctx.documentType + '/' + documentor.metadataID
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(documentor.metadataName), 1),
                    _createElementVNode("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documentor.files, (file, idx) => {
                        return (_openBlock(), _createBlock(ImageLoading, {
                          key: idx,
                          src: file.thumbnailURL,
                          "img-class": "w-32 h-48 shadow-md",
                          "loading-class": "w-32 h-48 shadow-md flex items-start"
                        }, null, 8, ["src"]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(documentor.metadataName), 1)
                ])
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128))
        ]))
      : (isFetching.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array(metadata.value.limit), (_, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "rounded-md shadow-md bg-white overflow-hidden"
              }, _hoisted_13))
            }), 128))
          ]))
        : (_openBlock(), _createBlock(_component_a_empty, {
            key: 2,
            class: "mt-2 sm:mt-4"
          })),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_unref(Pagination), {
        current: metadata.value.currentPage,
        "onUpdate:current": _cache[8] || (_cache[8] = ($event: any) => ((metadata.value.currentPage) = $event)),
        "page-size": metadata.value.limit,
        "onUpdate:pageSize": _cache[9] || (_cache[9] = ($event: any) => ((metadata.value.limit) = $event)),
        total: metadata.value.totalItem,
        "show-total": (total, range) => `${range[0]}-${range[1]} of ${total} items`,
        "show-size-changer": "",
        "show-quick-jumper": "",
        onChange: _cache[10] || (_cache[10] = 
				(page, pageSize) => {
					metadata.value.currentPage = page;
					metadata.value.limit = pageSize;
				}
			)
      }, null, 8, ["current", "page-size", "total", "show-total"])
    ])
  ], 64))
}
}

})